module.exports = __webpack_public_path__ + "static/media/personal_text.6dd20300.xlsx";